import { FC } from "react";
import Box from "@mui/material/Box";
import { Header } from "./Header/Header";
import { View } from "./View/View";
import { Filters } from "./UserFilters/Filters";
import { useWorkspaceStore } from "../../store/workspace/WorkspaceStore";
import { lightScrollbarStyle } from "../../styles/lightScrollbarStyle";
import { Stack } from "@mui/material";
import { ExportButton } from "./ExportModal/ExportButton";
import { ExportMenuButton } from "./ExportModal/ExportMenuButton";
import { ViewOption } from "../../types/workspace";
import { FilterConflictDialog } from "./UserFilters/FiltersDialog/FilterConflictDialog";
import FiltersProvider from "./UserFilters/FiltersContext";
import { useFeatureFlag } from "../../hooks/useLaunchDarkly";

const UNIFIED_EXPORT_FF = "maProjectSegmentImprovements";

export const Workspace: FC = () => {
  const workspace = useWorkspaceStore((state) => state.draft);
  const selectedView = useWorkspaceStore((state) => state.selectedView);
  const isUnifiedExportEnabled = useFeatureFlag(UNIFIED_EXPORT_FF);

  return workspace ? (
    <FiltersProvider>
      <Box
        flex={1}
        display="flex"
        flexDirection="row"
        marginBottom="10px"
        minWidth={0}
        maxWidth="100%"
        sx={{
          ...lightScrollbarStyle,
          overflowY: "auto",
          overflowX: "hidden",
        }}
      >
        {/* Add FilterConflictManager here to manage conflict dialogs */}
        <FilterConflictDialog />

        <Box
          padding="30px"
          display="flex"
          flexDirection="column"
          gap="20px"
          flex={1}
          minWidth={0}
          maxWidth="100%"
          width="100%"
        >
          <Header />
          <Stack
            direction="row"
            justifyContent="space-between"
            borderBottom={1}
            borderTop={1}
            borderColor={"grey.300"}
          >
            <Filters />
            {isUnifiedExportEnabled ? (
              <ExportMenuButton />
            ) : (
              selectedView === ViewOption.COMPANY_LIST && <ExportButton />
            )}
          </Stack>
          <View />
        </Box>
      </Box>
    </FiltersProvider>
  ) : (
    <></>
  );
};
